import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1.467c-6.1 0-11 4.79-11 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S18.1 1.467 12 1.467m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798m4.4-7.723L13 11.634v-5.28c0-.586-.4-.977-1-.977s-1 .391-1 .978v5.865q0 .586.6.88l4 1.955c.1.098.2.098.4.098q.6 0 .9-.587c.2-.39 0-.977-.5-1.27Z"
    }, null, -1)
  ]))]))
}
export default { render: render }